import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerLibroCespitiModalComponent } from './worker-libro-cespiti-modal';

export const WorkerLibroCespitiModalModule: string = ng
    .module('worker-libro-cespiti-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerLibroCespitiModalComponent', WorkerLibroCespitiModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-libro-cespiti-modal/worker-libro-cespiti-modal.module.ts